import axiosInstance from '../../config';
import { React, useEffect, useState } from 'react'
import { Link } from 'react-router-dom';
import './showcomment.css';
import DeleteIcon from '@mui/icons-material/Delete';

export default function Showcomment({ userId, postId, comment, uniqueKey, allcomments,setallcomments,setnumberOfComment}) {
    // const PF = process.env.REACT_APP_PUBLIC_FOLDER;
    const PF = "https://socialshub.netlify.app/images/";
    const [user, setuser] = useState({});
    const [loading, setloading] = useState(false);
    const [isDeletedComment, setisDeletedComment] = useState(false);

    useEffect(() => {
        const fetchUser = async () => {
            try {
                setloading(true);
                // console.log("enter into -------");
                const response = await axiosInstance.get(`/api/users?userId=${userId}`);
                // console.log(response.data);
                setuser(response.data);
                setloading(false);
            } catch (error) {
                console.log("error inside comment", error);
            }
        }
        fetchUser();
    }, [userId])

    const deleteFromCommentsArray = (currentUID, uniqueKey) => {
        // console.log(currentUID,uniqueKey)
        // for user site or frontend
        const newallcomments = allcomments.filter((temp) => { return temp.uniqueKey !== uniqueKey })
        setallcomments(newallcomments);
        setnumberOfComment(newallcomments.length);
    }

    // function for delete comment
    const deletecomment = async () => {
        try {
            setisDeletedComment(true)
            await axiosInstance.delete(`/api/posts/${postId}/deleteComment`, { data: { userId: window.localStorage.getItem('currentUID'), uniqueKey: uniqueKey } });
            deleteFromCommentsArray(window.localStorage.getItem('currentUID'), uniqueKey);
        } catch (error) {
            console.log('inside deleteComment Post', error);
        }
    }

    return (
        <>
            <div className='comment'>
                {loading ? "Loading comments..." : <div className="commentShow-profile">
                    <div className="comment-img">
                        <Link style={{'textDecoration':'none'}} to={"/profile/" + user._id}>
                            <img src={user.profilePic ? user.profilePic : PF + "person/noprofile.jpeg"} />
                        </Link>
                    </div>
                    <div className="commentdesc">
                        <h5>{user.username}</h5>
                        <span>{comment}
                            {userId == window.localStorage.getItem('currentUID') ? <div onClick={() => { deletecomment() }}><DeleteIcon style={{ 'marginLeft': '5px', 'color': 'red' }} /></div> : ''}
                        </span>
                    </div>
                </div>}
            </div>
        </>
    )
}